/**
 * CustomerTableSkeleton Component
 * Loading skeleton for customer table
 */

import React from 'react';
import { TableRow, TableCell, Skeleton, Box } from '@mui/material';
import { SKELETON_ROWS } from '../constants/customerTableConfig';

export const CustomerTableSkeleton: React.FC = () => {
  return (
    <>
      {Array.from({ length: SKELETON_ROWS }).map((_, index) => (
        <TableRow key={index}>
          <TableCell>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Skeleton variant="circular" width={40} height={40} />
              <Box>
                <Skeleton variant="text" width={120} />
                <Skeleton variant="text" width={160} />
                <Skeleton variant="text" width={140} sx={{ mt: 0.5 }} />
              </Box>
            </Box>
          </TableCell>
          <TableCell>
            <Skeleton variant="text" width={100} />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" width={60} />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" width={150} />
          </TableCell>
          <TableCell>
            <Skeleton variant="circular" width={24} height={24} />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default CustomerTableSkeleton;
